module.exports = __webpack_public_path__ + "static/new_meeting_room-e97e597b5e9dd6931df61c9c22535a07.webp";